<template>
  <v-app>
    <slot></slot>
    <loading-overlay :loading="loading" />
    <SnackBar />
    <MessageBox />
  </v-app>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useAppStore } from "../store/app";

import LoadingOverlay from "../components/shared/LoadingOverlay.vue";
import MessageBox from "@/components/shared/MessageBox.vue";
import SnackBar from "@/components/shared/SnackBar.vue";

export default {
  name: "BlankLayout",

  components: { LoadingOverlay, MessageBox, SnackBar },

  computed: {
    ...mapState(useAppStore, {
      messageVisible: (store) => store.messageVisible,
      message: (store) => store.message,
      loading: (store) => store.loading,
      messageBox: (store) => store.messageBox,
    }),
  },

  methods: {
    messageHandler(e) {
      if (!e) {
        this.hideMessage();
      }
    },

    ...mapActions(useAppStore, ["hideMessage"]),
  },
};
</script>
